import { render, staticRenderFns } from "./SectionSummary.vue?vue&type=template&id=28077bd3"
import script from "./SectionSummary.vue?vue&type=script&lang=js"
export * from "./SectionSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports